import { Api, TResponse } from '@/modules/common';
import { IBlockItem } from '../types';

export const libraryServices = {
  apiGetBlocks: (page: number, pageSize: number, filterParams: any): Promise<TResponse<{ blocks: IBlockItem[] }>> => {
    return Api.base.get('/api/block/allBlocks.html', {
      params: {
        page,
        limit: pageSize,
        tags: filterParams.tags,
        q: (filterParams.q || '').toLowerCase(),
        sort: filterParams.sort,
      },
    });
  },

  apiGetBlockCountTags: (): Promise<TResponse<{ blocks: IBlockItem[] }>> => {
    return Api.base.get('/api/block/useCase.html');
  },
};
